import React from 'react';
import { Navbar, Nav, NavDropdown, Container, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import {
    FaUserCog,
    FaUserShield,
    FaSignOutAlt,
    FaSignInAlt,
    FaUserPlus,
    FaEnvelope
} from 'react-icons/fa';
import { useAuth } from "../AuthContext/AuthContext";
import { useNavigate } from "react-router-dom";
import './Navbar.css';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';  // Add this import


const NavbarComponent = () => {
    const { t } = useTranslation('common');
    const navigate = useNavigate();
    const { isLoggedIn, logout, userRole, userDetails } = useAuth();

    // Handle user logout and redirect to login page
    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    // Generate user initials from first and last name
    const getUserInitials = () => {
        if (!userDetails.firstName || !userDetails.lastName) return '';
        return `${userDetails.firstName.charAt(0)}${userDetails.lastName.charAt(0)}`.toUpperCase();
    };

    return (
        <Navbar bg="dark" variant="dark" expand="lg" className="navbar-main">
            <Container>
                {/* Brand Logo and Title */}
                <LinkContainer to="/">
                    <Navbar.Brand className="d-flex align-items-center">
                        <img
                            src="assets/logo/pnud-logo-blue.svg"
                            alt="PNUD Logo"
                            className="navbar-logo"
                            style={{ width: '50px', marginRight: '15px' }}
                        />
                        <h2 className="navbar-title">{t('appTitle')}</h2>
                    </Navbar.Brand>
                </LinkContainer>

                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                    <Nav>
                        <LanguageSwitcher />
                        {isLoggedIn ? (
                            <>

                                {/* User Profile Menu */}
                                <NavDropdown
                                    title={<span className="user-initials">{getUserInitials()}</span>}
                                    id="user-dropdown"
                                    align="end"
                                    className="nav-dropdown"
                                >
                                    <NavDropdown.Header className="user-header">
                                        <FaEnvelope className="me-2" />
                                        <span className="email-text">{userDetails.email}</span>
                                    </NavDropdown.Header>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item onClick={handleLogout} className="logout-item">
                                        <FaSignOutAlt className="me-2" /> Logout
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </>
                        ) : (
                            // Authentication Buttons for Non-logged-in Users
                            <div className="auth-buttons">
                                <LinkContainer to="/login">
                                    <Button variant="outline-light" className="auth-button login-button">
                                        <FaSignInAlt className="button-icon" />
                                        <span className="button-text" style={{ marginLeft: '12px' }}>{t('login')}</span>
                                    </Button>
                                </LinkContainer>
                                <LinkContainer to="/user-registration-page">
                                    <Button variant="light" className="auth-button register-button">
                                        <FaUserPlus className="button-icon" />
                                        <span className="button-text" style={{ marginLeft: '12px' }}>{t('createAccount')}</span>
                                    </Button>
                                </LinkContainer>
                            </div>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default NavbarComponent;